<template>
  <TransitionRoot as="template" :show="openModals.length > 0">
    <Dialog class="relative z-50" @close="closeTopModal">
      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div
          class="flex min-h-full items-end justify-center p-4 sm:items-center sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 "
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 "
          >
            <DialogPanel
              class="fixed top-0 left-0 z-50 h-full max-h-full w-full max-w-full overflow-hidden"
            >
              <template v-for="(modal, index) of openModals" :key="index">
                <div
                  class="absolute inset-0 flex items-center justify-center"
                  :style="{ zIndex: 50 + index }"
                >
                  <!-- Individual backdrop for each modal with increasing opacity -->
                  <div
                    class="absolute inset-0 bg-neutral-950 transition-opacity duration-300"
                    :style="{ opacity: Math.min(0.5 + index * 0.15, 0.7) }"
                    @click="modal.close()"
                  />
                  <!-- Modal content with relative positioning -->
                  <div class="relative z-10 h-full w-full overflow-auto">
                    <ModalProvider :modal="modal">
                      <component :is="modal.vnode" />
                    </ModalProvider>
                  </div>
                </div>
              </template>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script setup lang="ts">
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue';
import { computed } from 'vue';
import { Modal } from './modal';
import ModalProvider from './ModalProvider.vue';

const openModals = computed(() => {
  const modals: Modal[] = Array.from(Modal.modals.value.values());
  return modals;
});

function closeTopModal() {
  Modal.closeTopModal();
}
</script>
